import {Component, ViewChild} from "@angular/core";
import {IOccasionService} from "../../../../../domain/occasions/IOccasionService";
import {Occasions} from "../../../../../../../../server/src/base/entities/occasion/Occasions";
import {OccasionsSorting} from "../../../../../domain/occasions/sorting/OccasionsSorting";
import {OccasionsFilters} from "../../../../../domain/occasions/filters/OccasionsFilters";
import {WaitingPopupComponent} from "../../../generic/popup/waitingPopup/waitingPopup";

@Component({
    selector: 'admin-occasions-presentation',
    styleUrls: ['./presentation.scss'],
    templateUrl: './presentation.html'
})
export class AdminOccasionsPresentationComponent {

    @ViewChild(WaitingPopupComponent) refreshPopupComponent:WaitingPopupComponent;

    private occasionService:IOccasionService;
    public occasions:Occasions;
    public occasionsFilters:OccasionsFilters;
    public occasionsSorting:OccasionsSorting;

    public waitingMessage:string = "Actualisation des occasions en cours";
    public successMessage:string = "Occasions actualisées";
    public errorMessage:string = "Erreur durant l'actualisation";

    constructor(occasionService: IOccasionService) {
        this.occasionService = occasionService;
        this.occasions = new Occasions();
        this.occasionsFilters = new OccasionsFilters(this.occasions);
        this.occasionsSorting = new OccasionsSorting(this.occasionsFilters);
    }

    ngOnInit(){
        this.occasionService.Occasions().then(occasions => {
            this.occasions.SetOccasions(occasions.Value());
            this.occasionsFilters.Update();
        })
    }

    public triggerRefresh(){
        this.refreshPopupComponent.Open();
        this.occasionService.Refresh().then(() => {
            this.GetOccasions().then(() => {
                this.refreshPopupComponent.Done(true);
            })
        }).catch(err => {
            this.refreshPopupComponent.Done(false);
        })
    }

    private GetOccasions():Promise<void>{
        return this.occasionService.Occasions().then(occasions => {
            this.occasions.SetOccasions(occasions.Value());
            this.occasionsFilters.Update();
            return Promise.resolve();
        })
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/occasions/presentation/presentation.ts